var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import GeneralInformationView from "../../components/partcreation/generalinformationview.vue";
import { closePoints, intersects, } from "../utilities/geometry";
import { createSheetMetalProfile, createSvg, defaultGeneralInformation, } from "../utilities/partcreation";
import { sheetMetalProfileParts, } from "../utilities/profilecreation";
import { SegmentType, } from "../utilities/wsi4_interfaces";
import { isNumber, } from "../utilities/wsi4_typeguards";
const safetyValue = 2.;
let SheetMetalProfile = class SheetMetalProfile extends Vue {
    constructor() {
        super(...arguments);
        this.depth = 50.;
        this.elements = [
            {
                flangeLength: 50.,
                innerAngleInDegrees: 135.,
                ccw: true,
            },
            {
                flangeLength: 50.,
                innerAngleInDegrees: 0.,
                ccw: true,
            },
        ];
        this.generalInformation = defaultGeneralInformation;
        this.path = [];
    }
    close() { }
    validInput(valid) { return valid; }
    transferData() {
        return {
            gasId: this.generalInformation.material.cuttingGasId,
            material: this.generalInformation.material.material,
            name: this.generalInformation.articleName,
            segments: this.path,
            thickness: this.depth,
        };
    }
    updateSvg() {
        const s = this.$el.querySelector(".part-creation-svg");
        if (s === undefined || s === null) {
            throw Error("Selector '.part-creation-svg' does not match");
        }
        if (s.contains(this.currentSvg)) {
            s.removeChild(this.currentSvg);
        }
        this.currentSvg = createSvg({
            outerPolygon: this.path,
            innerPolygons: [],
        }, {
            addMeasurements: true,
            profileParts: this.sheetMetalProfileParts,
        });
        s.appendChild(this.currentSvg);
    }
    updateData() {
        if (this.validWithoutIntersectionCheck) {
            this.path = createSheetMetalProfile(this.sheetMetalProfileParts, this.generalInformation.thickness);
            this.updateSvg();
            this.transferData();
        }
        this.validInput(this.valid);
    }
    updateGeneralInformation(g) {
        this.generalInformation = g;
        this.updateData();
    }
    isValidNumber(n) { return isNumber(n) && n > 0; }
    isInRange(n, max) { return n <= max; }
    minimalFlangeLengthByAngle(angle) {
        const openingWidth = this.shopConfig.minLowerDieOpeningWidths.find(m => m.thickness === this.generalInformation.thickness);
        if (openingWidth === undefined) {
            return undefined;
        }
        const factor = Math.cos(0.5 * angle);
        if (factor === 0.) {
            return 0.;
        }
        return (0.5 * openingWidth.openingWidth) / factor + safetyValue;
    }
    minimalFlangeLength(index) {
        const part = this.sheetMetalProfileParts[index];
        const beforePart = index === 0 ? undefined : this.sheetMetalProfileParts[index - 1];
        const m0 = this.minimalFlangeLengthByAngle(part.content.outerAngleInRadians);
        if (beforePart === undefined) {
            return m0;
        }
        const m1 = this.minimalFlangeLengthByAngle(beforePart.content.outerAngleInRadians);
        if (part.content.outerAngleInRadians === 0.) {
            return m1;
        }
        return m0 === undefined ? m1 : (m1 === undefined ? m0 : Math.min(m0, m1));
    }
    validFlangeLength(index) {
        if (!this.isValidNumber(this.elements[index].flangeLength)) {
            return false;
        }
        const minimal = this.minimalFlangeLength(index);
        return minimal === undefined ? false : this.elements[index].flangeLength >= minimal;
    }
    flangeErrorMessage(index) {
        var _a;
        if (this.validFlangeLength(index)) {
            return "";
        }
        const p = this.elements[index];
        if (!this.isValidNumber(p.flangeLength)) {
            return this.i18n.t("sizeInvalid");
        }
        return this.i18n.t("flangeLengthInvalid") + " " + ((_a = this.minimalFlangeLength(index)) !== null && _a !== void 0 ? _a : -1)
            .toFixed(2) + " mm.";
    }
    validAngle(index) {
        const a = this.elements[index].innerAngleInDegrees;
        if (!isNumber(a)) {
            return false;
        }
        if (index === this.elements.length - 1) {
            return a === 0.;
        }
        if (a === 0.) {
            return false;
        }
        return a >= 30. && a < 180.;
    }
    angleToolTip(index) {
        if (index === this.elements.length - 1) {
            return this.i18n.t("lastAngle0");
        }
        if (this.validAngle(index)) {
            return "";
        }
        const a = this.elements[index].innerAngleInDegrees;
        if (!isNumber(a)) {
            return this.i18n.t("sizeInvalid");
        }
        return this.i18n.t("validInnerAngleRange") + "[30°, 180°)";
    }
    addElement() {
        this.elements[this.elements.length - 1].innerAngleInDegrees = 135.;
        this.elements.push({
            flangeLength: 50.,
            innerAngleInDegrees: 0.,
            ccw: true,
        });
        this.updateData();
    }
    removeElement(index) {
        this.elements.splice(index, 1);
        this.elements[this.elements.length - 1].innerAngleInDegrees = 0.;
        this.updateData();
    }
    updateCcw(index) {
        this.elements[index].ccw = !this.elements[index].ccw;
        this.updateData();
    }
    get sheet() {
        const allowedSheets = this.shopConfig.sheets.filter(s => s.thickness === this.generalInformation.thickness && s.sheetMaterialId === this.generalInformation.material.material.identifier);
        if (allowedSheets.length === 0) {
            return undefined;
        }
        return allowedSheets.reduce((res, s) => (s.dimX * s.dimY > res.dimX * res.dimY) ? s : res, allowedSheets[0]);
    }
    get sheetSizeBorder() { return 40.; }
    get maximalDimX() { return this.sheet === undefined ? 0. : this.sheet.dimX - this.sheetSizeBorder; }
    get maximaldimY() { return this.sheet === undefined ? 0. : this.sheet.dimY - this.sheetSizeBorder; }
    get violatedMaximalSizeMessage() { return this.i18n.t("maxSizeInvalid") + this.maximalDimX.toString() + " x " + this.maximaldimY.toString() + " [mm²]."; }
    get maxSheetSizeViolated() { return !this.widthInRange || !this.depthInRange; }
    get approximateWidth() { return this.elements.reduce((w, p) => w + p.flangeLength, 0.); }
    get widthInRange() { return this.approximateWidth > this.depth ? this.isInRange(this.approximateWidth, this.maximalDimX) : this.isInRange(this.approximateWidth, this.maximaldimY); }
    get depthInRange() { return this.approximateWidth > this.depth ? this.isInRange(this.depth, this.maximaldimY) : this.isInRange(this.depth, this.maximalDimX); }
    get depthErrorMessage() {
        if (!this.isValidNumber(this.depth)) {
            return this.i18n.t("sizeInvalid");
        }
        if (!this.depthInRange) {
            return this.violatedMaximalSizeMessage;
        }
        return "";
    }
    get depthValid() { return this.depthErrorMessage === ""; }
    get flangeLengthsValid() { return this.elements.every((_p, index) => this.validFlangeLength(index)); }
    get anglesValid() { return this.elements.every((_p, index) => this.validAngle(index)); }
    get noIntersections() {
        for (let i = 0; i < this.path.length; ++i) {
            const pi = this.path[i];
            if (pi.type === SegmentType.arc) {
                continue;
            }
            for (let j = i + 1; j < this.path.length; ++j) {
                const pj = this.path[j];
                if (pj.type === SegmentType.arc) {
                    continue;
                }
                if (closePoints(pj.content.from, pi.content.to)) {
                    continue;
                }
                if (closePoints(pj.content.to, pi.content.from)) {
                    continue;
                }
                if (intersects(pi.content, pj.content)) {
                    return false;
                }
            }
        }
        return true;
    }
    get generalErrorMessages() {
        const e = [];
        if (this.maxSheetSizeViolated) {
            e.push(this.violatedMaximalSizeMessage);
        }
        if (!this.noIntersections) {
            e.push(this.i18n.t("segmentsIntersect"));
        }
        return e;
    }
    get validWithoutIntersectionCheck() {
        if (!this.generalInformation.valid) {
            return false;
        }
        if (!this.flangeLengthsValid) {
            return false;
        }
        if (!this.anglesValid) {
            return false;
        }
        if (!this.depthValid) {
            return false;
        }
        if (this.maxSheetSizeViolated) {
            return false;
        }
        return true;
    }
    get valid() {
        if (!this.validWithoutIntersectionCheck) {
            return false;
        }
        if (!this.noIntersections) {
            return false;
        }
        return true;
    }
    get sheetMetalProfileParts() {
        return sheetMetalProfileParts(this.elements, this.generalInformation.thickness);
    }
    mounted() { this.updateData(); }
};
__decorate([
    Prop({ required: true })
], SheetMetalProfile.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], SheetMetalProfile.prototype, "i18n", void 0);
__decorate([
    Emit()
], SheetMetalProfile.prototype, "close", null);
__decorate([
    Emit()
], SheetMetalProfile.prototype, "validInput", null);
__decorate([
    Emit()
], SheetMetalProfile.prototype, "transferData", null);
SheetMetalProfile = __decorate([
    Component({
        components: {
            GeneralInformationView,
        },
        name: "SheetMetalProfile",
    })
], SheetMetalProfile);
export default SheetMetalProfile;
